// src/modules/app-views/dataSearch/pages/Search/components/SearchHeader.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, theme } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { openModal } from 'components/core/GenericModal';
import InfoModal from '../modals/InfoModal';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SearchHeader = ({
  isMobile,
  showDescription = false,
  showLearnMore = false,
  children,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={isMobile ? { padding: '40px 0' } : { height: '100%' }}
    >
      <ApiOutlined
        style={{
          fontSize: isMobile ? 64 : 80,
          color: token.colorPrimary,
          marginBottom: 24,
        }}
      />
      <div
        className="text-center"
        style={{
          fontSize: isMobile ? 18 : 28,
          fontWeight: 500,
          marginBottom: showDescription ? 24 : 8,
        }}
      >
        {translateX('api_data_search')}
      </div>

      {/* Optional description (WelcomeScreen) */}
      {showDescription && (
        <div
          style={{
            fontSize: 14,
            marginBottom: 8,
            color: token.colorTextSecondary,
            textAlign: 'center',
            maxWidth: 400,
          }}
        >
          {translateX('data_search_welcome_description')}
        </div>
      )}

      {/* Optional learn more link (EmptyState) */}
      {showLearnMore && (
        <a
          onClick={() => openModal(InfoModal)}
          style={{ fontSize: 14, marginBottom: 24, cursor: 'pointer' }}
        >
          {translateX('learn_more')}
        </a>
      )}

      {/* Additional content passed as children */}
      {children}
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SearchHeader;
